import { Component, ViewEncapsulation, Inject, PLATFORM_ID, Optional } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'oops',
    styleUrls: ['./oops.component.scss'],
    templateUrl: './oops.component.html',
    encapsulation: ViewEncapsulation.Emulated
})
export class OopsComponent {
    public errorCode: number;
    public homepageUrl: string;
    public cityUrl: string;

    constructor(private route: ActivatedRoute, private router: Router, private translate: TranslateService, @Inject(PLATFORM_ID) platformId: Object, @Optional()
    @Inject(RESPONSE) private response: any) {

        route.params.subscribe(params => {
            this.errorCode = +params['errorCode'];
            if (isPlatformServer(platformId)) {
                this.errorCode = this.httpStatusCodeValid(this.errorCode);
                this.response.status(this.errorCode);
            }
        });


        this.transformUrl('HOME_URL').subscribe(path => {
            this.homepageUrl = `/${this.translate.getDefaultLang()}/${path}`;
        });
    }

    httpStatusCodeValid(code: number): number {
        let status: number[] = [100, 101, 200, 201, 202, 203, 204, 205, 206, 300, 301,
            302, 303, 304, 305, 306, 307, 400, 401, 402, 403, 404,
            405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415,
            416, 417, 500, 501, 502, 503, 504, 505];
        if (status.indexOf(code) != -1) {
            return code;
        } else {
            return 500;
        }

    }

    transformUrl(urlToTranslate) {
        return this.translate.get(urlToTranslate);
    }

    navToHome() {
        this.router.navigate([this.homepageUrl]);
    }

    navToCity(id) {
        //TODO change to translate
        let url = `/es/${id}`;
        switch (id) {
            case 1:
                this.router.navigate([url, 'sevilla']);
                break;
            case 19:
                this.router.navigate([url, 'cadiz']);
                break;
            case 20:
                this.router.navigate([url, 'cordoba']);
                break;
            case 22:
                this.router.navigate([url, 'las-palmas-de-gran-canaria']);
                break;
            case 24:
                this.router.navigate([url, 'malaga']);
                break;
            case 25:
                this.router.navigate([url, 'palma-de-mallorca']);
                break;
            case 28:
                this.router.navigate([url, 'toledo']);
                break;
            case 27:
                this.router.navigate([url, 'santander']);
                break;
            case 26:
                this.router.navigate([url, 'santa-cruz-de-tenerife']);
                break;

            default:
                break;
        }
    }
}